export default [
  {
    path: '/settings',
    name: 'Settings Panel',
    meta: { RequiresAuth: true },
    component: () => import('@/layouts/DefaultLayout.vue'),
    children: [
      {
        path: '',
        name: 'Settings', // Ensure a unique name
        component: () => import('@/views/SettingsPages/AccountSettings.vue'),
      },
      {
        path: 'Notification_Settings',
        name: 'Notification Settings',
        component: () => import('@/views/SettingsPages/NotificationSettings.vue'),
      },
    ],
  },
];
